import { useState } from 'react';

/** Versioned, so a rewritten hint shows again to users who dismissed the old one. */
const STORAGE_KEY = 'projectGraph.help.v1';
const DISMISSED = 'dismissed';

// Storage can be missing or throw (a private window, blocked site data); the hint then shows on every visit.
function readDismissed(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === DISMISSED;
  } catch {
    return false;
  }
}

function writeDismissed() {
  try {
    window.localStorage.setItem(STORAGE_KEY, DISMISSED);
  } catch {
    // The dismissal then lasts for this visit only.
  }
}

/** The first-use hint strip: shown until dismissed, and shown again on request. */
export function useGraphHelp() {
  const [shown, setShown] = useState(() => !readDismissed());
  const dismiss = () => {
    setShown(false);
    writeDismissed();
  };
  const show = () => setShown(true);
  return { shown, dismiss, show };
}
